// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-RefSelect-RefSelect-module__plusCircleFilled--OB5eP {
  color: #fc4807;
}
/*# sourceMappingURL=RefSelect.module.css.map */`, "",{"version":3,"sources":["webpack://./RefSelect.module.less","webpack://./src/components/RefSelect/RefSelect.module.less"],"names":[],"mappings":"AAEA;EACE,cAAA;ACDF;AACA,+CAA+C","sourcesContent":["@import \"../../variables.less\";\n\n.plusCircleFilled {\n  color: @primary-orange;\n}\n",".plusCircleFilled {\n  color: #fc4807;\n}\n/*# sourceMappingURL=RefSelect.module.css.map */"],"sourceRoot":""}]);
// Exports
export var plusCircleFilled = `src-components-RefSelect-RefSelect-module__plusCircleFilled--OB5eP`;
export default ___CSS_LOADER_EXPORT___;
